
import React from 'react';
import "./ProductAdminRow.css"

function ProductAdminRow({title, price, category, rating}) {
    return (
        <div className="orderRow">
           <span className="title">{title}</span>
           <span className="price">{price}</span>
           <span className="category">{category}</span>
           <span className="rating">{rating}</span>
        </div>
    )
}

export default ProductAdminRow
